export const SET_EDIT_KIOSK_DATA = 'SET_EDIT_KIOSK_DATA';

export function setEditKioskData(kiosk) {
  return {
    type: SET_EDIT_KIOSK_DATA,
    kiosk,
  };
}
